import React, { useState } from 'react';

import { Box, Tab, Tabs, Typography } from '@mui/material';

import PermissionedComponent from '~/components/Common/PermissionedComponent';

import { ROLE_ADMIN_USER, ROLE_LUX_LOYALTY_ADMIN } from '~/consts/roles';

import InfiniteApplicationsPage from '../InfiniteApplications/InfiniteApplicationsPage';
import { loyaltySubTabsContainerSx } from '../loyaltyTabStyles';

import ConciergeTab from './ConciergeTab';
import CreateInfiniteAccountTab from './CreateInfiniteAccountTab';
import CurrentInfiniteUsersTab from './CurrentInfiniteUsersTab';

type ParentTabKey = 'applications' | 'current-users' | 'eligible-users' | 'create-account' | 'concierge';

/**
 * Top-level Infinite page.
 *  - Applications: review Infinite applications.
 *  - Current users: searchable, view-only list of members enrolled on Infinite.
 *  - Eligible users: people invited to apply.
 *  - Infinite Enrolment: upgrade an existing customer or register a new one at Infinite.
 *  - Concierge: assignments and representatives.
 */
export default function InfiniteConciergePage() {
  const [tab, setTab] = useState<ParentTabKey>('applications');

  return (
    <PermissionedComponent
      requiredRoles={[ROLE_ADMIN_USER, ROLE_LUX_LOYALTY_ADMIN]}
      fallback={
        <Typography color="text.secondary">You don&apos;t have permission to manage Infinite assignments.</Typography>
      }
    >
      <Box sx={loyaltySubTabsContainerSx}>
        <Tabs value={tab} onChange={(_, next) => setTab(next as ParentTabKey)}>
          <Tab value="applications" label="Applications" />
          <Tab value="current-users" label="Current Users" />
          <Tab value="eligible-users" label="Eligible Users" />
          <Tab value="create-account" label="Infinite Enrolment" />
          <Tab value="concierge" label="Concierge" />
        </Tabs>
      </Box>

      {tab === 'applications' && <InfiniteApplicationsPage view="applications" />}
      {tab === 'current-users' && <CurrentInfiniteUsersTab />}
      {tab === 'eligible-users' && <InfiniteApplicationsPage view="eligible-users" />}
      {tab === 'create-account' && <CreateInfiniteAccountTab />}
      {tab === 'concierge' && <ConciergeTab />}
    </PermissionedComponent>
  );
}
